module.exports = __webpack_public_path__ + "img/gala-logo_horizontal_white.8b0409c.png";